export * from './eintrag-post-request.interface';
export * from './eintrag-post-response.interface';
export * from './eintrag-post.shapes';
